import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Underline = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        opacity="0.98"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2H11.1618V8.64514C11.1618 9.1329 11.1432 9.56702 10.9221 9.94748C10.7044 10.3247 10.3894 10.6222 9.97739 10.8401C9.56533 11.0547 9.07286 11.162 8.5 11.162C7.92714 11.162 7.43467 11.0547 7.02261 10.8401C6.6139 10.6222 6.29899 10.3247 6.07789 9.94748C5.85678 9.56702 5.83444 9.1329 5.83444 8.64514V2H4.5V8.94905C4.5 9.63192 4.66415 10.2416 4.99246 10.7782C5.32412 11.3115 5.78978 11.7326 6.38945 12.0415C6.98911 12.3472 7.69263 12.5 8.5 12.5C9.30737 12.5 10.0109 12.3472 10.6106 12.0415C11.2102 11.7326 11.6742 11.3115 12.0025 10.7782C12.3342 10.2416 12.5 9.68288 12.5 9V2ZM13 13.5H4V14.5H13V13.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Underline
